import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fs-appliance-capacity-indicator',
  templateUrl: './appliance-capacity-indicator.html',
  styleUrls: ['./appliance-capacity-indicator.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceCapacityIndicatorComponent {
  // Constants
  private readonly _warningThresholdPercent = 75;
  private readonly _dangerThresholdPercent = 100;
  private _value = 0;

  @Input()
  public set value(val: number) {
    this._value = Math.max(0, val); // Ensure non-negative
  }

  public get value(): number {
    return this._value;
  }

  get colorClass(): string {
    if (this.value >= this._dangerThresholdPercent) {
      return 'danger';
    } else if (this.value > this._warningThresholdPercent) {
      return 'warning';
    } else {
      return 'success';
    }
  }
}
